import React from 'react';

import { Image, Container, Card, Segment, Label } from 'semantic-ui-react';

import Image1 from '../../../assets/About/Telegram/1.jpg'
import Image2 from '../../../assets/About/Telegram/2.jpg'
import Image3 from '../../../assets/About/Telegram/3.jpg'
import Image4 from '../../../assets/About/Telegram/4.jpg'
import Image5 from '../../../assets/About/Telegram/5.jpg'




const AboutTbot: React.FC = () => {

    return (
        <Container>
            <Segment inverted></Segment>
            <Card.Group
                itemsPerRow={3}
                stackable
            >

                <Card style={{ background: 'black' }} >
                    <Card.Content>
                        <Image src={Image1} size='medium' />
                        <Card.Description style={{ color: 'white' }}>Для подключения Telegram-бота, следует перейти по ссылке:
                            <Label as="a"
                                href="https://t.me/beehoneyby_bot"
                                color="blue"
                                target="_blank"                            >"чудесный бот"</Label>
                            .</Card.Description>

                    </Card.Content>
                </Card>

                <Card style={{ background: 'black' }}>
                    <Card.Content>
                        <Image src={Image2} size='medium' />
                    </Card.Content>
                </Card>

                <Card style={{ background: 'black' }}>
                    <Card.Content>
                        <Image src={Image3} size='medium' />

                        <Card.Description style={{ color: 'white' }}>Далее заходим на сайте в профиль.</Card.Description>

                    </Card.Content>
                </Card>

                <Card style={{ background: 'black' }}>
                    <Card.Content>
                        <Image src={Image4} />

                    </Card.Content>
                </Card>

                <Card style={{ background: 'black' }}>
                    <Card.Content>
                        <Image src={Image5} />
                    </Card.Content>
                </Card>

            </Card.Group>
            <Segment inverted></Segment>
        </Container>

    );
}

export default AboutTbot;